import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import {CommonModule} from "@angular/common";
import { FormBuilder, FormControl, FormGroup, Validators, ReactiveFormsModule  } from '@angular/forms';
import { VideoRequest } from 'src/models/video-request';
import { phoneNumberValidator } from 'src/shared/phone-validator';
//import { dualNameValidator } from 'src/shared/dual-name-validator';
//import { setTheme } from 'ngx-bootstrap/utils';
import { DeviceDetectorService } from 'ngx-device-detector';
import { EsriMap } from 'src/esriMap/esri-maps';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import moment from 'moment';

@Component({
  selector: 'app-root',
  imports: [CommonModule, ReactiveFormsModule, EsriMap, MatDatepickerModule, MatFormFieldModule, MatNativeDateModule ],
  templateUrl: 'app.html',
  styleUrls: ['./app.css'],
})
export class App implements OnInit {
   @ViewChild(EsriMap, {static: false}) private myMap!:EsriMap;
  title = 'iowa-video-request';
  exampleForm: FormGroup;
  isMobile: boolean = false;
  isError: boolean = false;
  isComplete: boolean = false;
  pickedCameras: any[] = [];
  isValidate: boolean = false;
  successMsg: string = '';
  startDateTime: Date = new Date();
  endDateTime: Date = new Date();
  disableSubmit: boolean = false;

  constructor(fb: FormBuilder, private deviceService: DeviceDetectorService) {
    this.checkForMobileUsage();
    //setTheme('bs4');
    this.exampleForm = fb.group({
      personName: fb.control('', [Validators.required]),
      company: fb.control(''),
      email: fb.control('', [Validators.required, Validators.email]),
      phone: fb.control('', [Validators.required, phoneNumberValidator]),
      additionalInfo: fb.control(''),
      reason: fb.control('', [Validators.required, Validators.minLength(5)]),
      dateStart: fb.control(new Date(), [Validators.required]),
      dateEnd: fb.control(new Date(), [Validators.required]),
      userType: fb.control("-1", [Validators.required]),
      isUrgent: fb.control(false),
      timeStart: fb.control(new Date(), [Validators.required]),
      timeEnd: fb.control(new Date(), [Validators.required]),
      isFatality: fb.control('', [Validators.required]),
    });
  }

  ngOnInit(): void {
  }

  checkForMobileUsage() {
    //console.log('hello `Home` component');
    //this.deviceInfo = this.deviceService.getDeviceInfo();
    this.isMobile = this.deviceService.isMobile();
    //const isTablet = this.deviceService.isTablet();
    //const isDesktopDevice = this.deviceService.isDesktop();
    //console.log(this.deviceInfo);
    console.log('Is Mobile: ' + this.isMobile);  // returns if the device is a mobile device (android / iPhone / windows-phone etc)
    //console.log(isTablet);  // returns if the device us a tablet (iPad etc)
    //console.log(isDesktopDevice); // returns if the app is running on a Desktop browser.
  }

   createFinalForm(final: any): VideoRequest {
    let f = new VideoRequest();
    f.NAME = final.personName;
    f.COMPANY = final.company;
    f.EMAIL = final.email;
    f.PHONE = final.phone;
    if(final.isUrgent) {
      f.ADDITIONAL_INFO = "!!!URGENT!!!";
    }
    f.REASON = final.reason;
    f.CAMERAS = this.pickedCameras.map(x => {return x.attributes['COMMON_ID'];}).join(',');
    f.TIME_START = moment(this.startDateTime).valueOf();
    f.TIME_END = moment(this.endDateTime).valueOf();
    f.USER_TYPE = Number.parseInt(final.userType);
    f.START_TIME = moment(this.startDateTime).format("L LTS");
    f.END_TIME = moment(this.endDateTime).format("L LTS");
    f.Fatality = final.isFatality;
    f.Urgent = final.isUrgent;

    return f;
  }

  mapLoadedEvent(status: boolean) {
    console.log('The map loaded: ' + status);
  }

    pickedCameraEvent(cameras: any[]) {
    this.pickedCameras = cameras;
  }

  onNewForm() {
    //document.location.href = 'https://iowadot.gov/511/traffic-video-requests';
    document.location.reload();
  }

  onSubmit(): void {
    this.disableSubmit = false;
    if(this.exampleForm.get('userType')?.value !== "4") {
      // Only Law Enforcement can mark as isUrgent
      this.exampleForm.patchValue({ 'isUrgent': false}, {onlySelf: true});
    }
  
    this.successMsg = "";
    // Verify Date & Times are within reason.

    //if(this.isMobile) {
      let sdate: Date = new Date(this.exampleForm.get('dateStart')?.value.replace(/-/g, '\/'));
      let stime: any =  moment(this.exampleForm.get('timeStart')?.value, "hh:mm");
      this.startDateTime = new Date(sdate.getFullYear(), sdate.getMonth(), sdate.getDate(), stime.hour(), stime.minute(), 0, 0);
  
      let edate: Date = new Date(this.exampleForm.get('dateEnd')?.value.replace(/-/g, '\/'));
      let etime: any = moment(this.exampleForm.get('timeEnd')?.value, "hh:mm");
      this.endDateTime = new Date(edate.getFullYear(), edate.getMonth(), edate.getDate(), etime.hour(), etime.minute(), 0, 0);
    //} else {
    //  let sdate: Date = this.exampleForm.get('dateStart')?.value;
    //  let stime: Date = this.exampleForm.get('timeStart')?.value;
    //  this.startDateTime = new Date(sdate.getFullYear(), sdate.getMonth(), sdate.getDate(), stime.getHours(), stime.getMinutes(), 0, 0);
  
    //  let edate: Date = this.exampleForm.get('dateEnd')?.value;
    //  let etime: Date = this.exampleForm.get('timeEnd')?.value;
    //  this.endDateTime = new Date(edate.getFullYear(), edate.getMonth(), edate.getDate(), etime.getHours(), etime.getMinutes(), 0, 0);
    //}
    
    if(this.startDateTime > this.endDateTime) {
      alert('Start Date & Time is after End Date & Time. Please correct this.');
      return;
    }

    if(this.endDateTime.getFullYear() < 2014) {
      alert('Cannot go before January 1st, 2014. Recordings do not exist before that time frame.');
      return;
    }

    if(this.pickedCameras.length == 0) {
      alert('No cameras are selected, please choose them from the map.');
      return;
    }

    // Verify with user the # of cameras and time frame of footage
    let duration = (this.endDateTime.getTime() - this.startDateTime.getTime()) / 3600000.0; // total hours
    duration = Math.ceil(duration)
      let x = confirm('You have requested approxmately '+ duration +' hour(s) of footage from '+ this.pickedCameras.length +' camera(s). Are you sure?');
      if(!x) {
        return;
      }

    // Show validation screen
    this.isValidate = true;
    // On map, zoom to selected cameras.
    this.myMap.centerAndZoomToCameras();
  }

   async onValidate(isReady: boolean) {
    if(!isReady) {
      this.isValidate = false;
    } else {
      // Submit form to Iowa
      let final = this.exampleForm.value;
      let form = this.createFinalForm(final);
      let result = await this.myMap.submitForm(form);
      if(result) {
        this.successMsg = "Your request has been submitted to the Iowa DOT's video request team. Instructions for downloading your requested video -- or an explanation if your video is not available -- will be sent to you within 3 business days.";
        this.isError = false;
        this.isComplete = true;
      } else {
        this.successMsg = "There was an error submitting your request. Please contact our office if issue persists @ DOT-CameraVidReq@iowadot.us";
        this.isError = true;
        this.isComplete = true;
      }
      this.disableSubmit = false;
      window.scroll(0, 0);
    }
  }

  validateUserType(form: FormGroup ) {
    let x: number = Number.parseInt(form.value);
    return x > -1 ? null : {valid: false}; 
  }

   get personName() {
    return this.exampleForm.get('personName');
  }

  get company() {
    return this.exampleForm.get('company');
  } 

  get email() {
    return this.exampleForm.get('email');
  }

  get phone() {
    return this.exampleForm.get('phone');
   }

  get additionalInfo() {
    return this.exampleForm.get('additionalInfo');
   }

  get reason() {
    return this.exampleForm.get('reason');
  }

  get userType() {
   return this.exampleForm.get('userType');
  }

  get userTypeName() {
    let u = this.exampleForm.get('userType')?.value;
    switch (u) {
      case '0': return 'Attorney';
      case '1': return 'DOT Consultant';
      case '2': return 'Government agency';
      case '3': return 'Insurance company';
      case '4': return 'Law enforcement';
      case '5': return 'Media';
      case '6': return 'Private citizen';
    }

    return '';
  }

  get isUrgent() {
    return this.exampleForm.get('isUrgent');
   }

   get isFatality() {
    let x = this.exampleForm.get('isFatality')?.value;

    switch(x) {
      case 'No': return 'No';
      case 'Yes': return 'Yes';
      case 'Possibly': return 'Possibly';
    }

    return '';
   }
}
